






























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class DisplayField extends Vue {
  @Prop({ required: false, type: String, default: undefined })
  private label!: string;

  @Prop({ required: false, default: '' })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private value!: string | number | any;

  @Prop({ required: false, type: Boolean, default: true })
  private displayInline!: boolean;
}
